import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-pressed"]

import { Heart } from 'lucide-vue-next';

type Size = 'xs' | 'sm' | 'md' | 'lg';


export default /*@__PURE__*/_defineComponent({
  __name: 'FavoriteButton',
  props: {
    isFavorite: { type: Boolean },
    size: { default: 'md' }
  },
  emits: ["toggle"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const sizeClasses: Record<Size, string> = {
  xs: 'h-4 w-4',
  sm: 'h-5 w-5',
  md: 'h-6 w-6',
  lg: 'h-7 w-7',
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "btn-bare",
    "aria-pressed": _ctx.isFavorite,
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('toggle')), ["stop","prevent"]))
  }, [
    _createVNode(_unref(Heart), {
      class: _normalizeClass([sizeClasses[_ctx.size], 'text-foreground transition-colors']),
      fill: _ctx.isFavorite ? 'currentColor' : 'none'
    }, null, 8, ["class", "fill"])
  ], 8, _hoisted_1))
}
}

})